import { useEffect, useState } from 'react'

const sleep = async (ms: number) => new Promise(resolve => setTimeout(resolve, ms))

const useDelayedMount = (ms: number) => {
  const [delay, setDelay] = useState(false)
  useEffect(() => {
    let subscribed = true
    const load = async () => {
      await sleep(ms)
      if (subscribed) setDelay(true)
    }
    load()
    return () => {
      subscribed = false
    }
  }, [setDelay, ms])
  return delay
}

export default useDelayedMount
